import React from 'react';

function FaqProjects(
  props: JSX.IntrinsicAttributes & React.SVGProps<SVGSVGElement>
): JSX.Element {
  return (
    <svg
      width={52}
      height={52}
      viewBox='0 0 52 52'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...props}
    >
      <rect width={52} height={52} rx={4} fill='#DFD8F3' />
      <mask
        id='mask0_9879_72220'
        style={{
          maskType: 'alpha'
        }}
        maskUnits='userSpaceOnUse'
        x={10}
        y={10}
        width={32}
        height={32}
      >
        <rect x={10} y={10} width={32} height={32} fill='#D9D9D9' />
      </mask>
      <g mask='url(#mask0_9879_72220)'>
        <path
          d='M14.0783 13.8698C16.2237 13.8698 18.2999 13.8516 20.7623 13.8516C21.8332 13.9426 22.2011 14.3834 22.8239 15.3705C23.1736 15.9242 23.8548 16.9841 24.1717 17.4431H38.0861C39.0696 17.5414 39.9001 18.2954 40.002 19.3008V36.0964C39.8855 37.2001 38.9603 38.0925 37.853 38.1872H14.1584C13.1276 38.0961 12.2825 37.3348 12.0858 36.3149C11.911 29.5945 12.0603 22.8486 12.0093 16.1208C12.0494 15.0135 12.9418 13.8698 14.0783 13.8698ZM20.4927 16.0917H14.3078V22.1019L37.7546 22.0144V19.6869H23.527C23.1153 19.6869 22.7511 19.4792 22.5544 19.1842L20.4927 16.0917ZM30.965 24.4731C30.7756 24.5059 30.4878 24.6625 30.3312 24.7827L24.3538 30.7055C23.6909 30.1955 22.6309 28.6438 21.815 28.5309C20.5547 28.356 19.7752 29.5289 20.6093 30.5598C21.1957 31.281 22.864 32.9529 23.5889 33.5321C24.1025 33.94 24.6598 34.0748 25.1807 33.594L32.3163 26.4146C32.9137 25.4712 32.0249 24.2983 30.965 24.4768V24.4731Z'
          fill='#AF9DE0'
        />
      </g>
    </svg>
  );
}

FaqProjects.displayName = 'FaqProjects';

export default FaqProjects;
